module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-map-fa7861e1ea21245b69c0bf1b28304594.svg";